import { css } from 'styled-components';

/**
 * The brand palette (Tigaly orange) for pages that have moved to the new design, while
 * the rest of the app keeps the older global --hd-* palette from tokens.js.
 *
 * Include `brandTheme` in a page's root styles: it re-points the same --hd-*
 * names, so every rule underneath that reads var(--hd-primary),
 * var(--hd-gradient-houdiny) and friends picks up the brand colours with no
 * further change. Portaled overlays render outside that root, so each one
 * includes it too.
 *
 * Once every page is on the new design, these values can move into
 * tokens.js itself and this scope can be dropped. Only the tokens that differ
 * are listed; the neutrals already match tokens.js.
 */
export const brandTheme = css`
  --hd-primary: oklch(0.703 0.198 43.4) /* #FF6B1A */;
  --hd-primary-foreground: oklch(0.166 0.038 61.8) /* #1A0A00 */;
  --hd-accent: oklch(0.96 0.02 50);
  --hd-ring: var(--hd-primary);
  --hd-houdiny-from: var(--hd-primary);
  --hd-houdiny-to: oklch(0.15 0.02 55);
  --hd-gradient-houdiny: linear-gradient(
    135deg,
    oklch(0.744 0.168 47.9) 0%,
    oklch(0.56 0.17 42) 48%,
    oklch(0.13 0.02 55) 100%
  );
  --hd-gradient-soft: linear-gradient(
    135deg,
    color-mix(in oklab, var(--hd-primary) 9%, transparent) 0%,
    color-mix(in oklab, var(--hd-foreground) 5%, transparent) 100%
  );
  /* Gradient headline text; the dark ramp ends light so the text stays legible. */
  --hd-gradient-text: var(--hd-gradient-houdiny);
  /* version3's bg-gradient-brand: orange into amber, on outgoing chat bubbles. */
  --hd-gradient-brand: linear-gradient(110deg, var(--hd-primary), oklch(0.77 0.165 62), oklch(0.79 0.16 76));
  --hd-shadow-card-hover: 0 1px 2px rgba(15, 23, 42, 0.05),
    0 24px 48px -20px color-mix(in oklab, var(--hd-primary) 22%, transparent);

  html.dark &,
  [data-theme='dark'] & {
    --hd-primary: oklch(0.744 0.168 47.9) /* #FF8640 */;
    --hd-primary-foreground: oklch(0.166 0.038 61.8) /* #1A0A00 */;
    --hd-accent: oklch(0.25 0.045 45);
    --hd-ring: var(--hd-primary);
    --hd-houdiny-from: var(--hd-primary);
    --hd-houdiny-to: oklch(0.08 0.01 55);
    --hd-gradient-houdiny: linear-gradient(
      135deg,
      oklch(0.744 0.168 47.9) 0%,
      oklch(0.52 0.16 42) 48%,
      oklch(0.08 0.01 55) 100%
    );
    --hd-gradient-soft: linear-gradient(
      135deg,
      color-mix(in oklab, var(--hd-primary) 15%, transparent) 0%,
      color-mix(in oklab, var(--hd-foreground) 6%, transparent) 100%
    );
    --hd-gradient-text: linear-gradient(135deg, var(--hd-primary) 0%, oklch(0.85 0.1 60) 100%);
    --hd-shadow-card-hover: 0 1px 2px rgba(0, 0, 0, 0.4),
      0 24px 48px -20px color-mix(in oklab, var(--hd-primary) 38%, transparent);
  }
`;
